import React from 'react'

function PageTitle({pageTitle}) {
  return (
    <h3 className="text-16 font-bold mt-[-3.6rem] mb-[2rem]"><span className="relative z-1">{pageTitle}</span></h3>
  )
}
export default PageTitle;